import React from "react";
import Section from "../../components/section/section";
import Footer from "../../components/footer/footer";
import ChooseRide from "../../components/chooseride/chooseride";
import Navbar from "../../components/navbar/navbar";

function Homepage() {
  return (
    <div className="homepage-wrapper">
      <Navbar />
      <ChooseRide />
      <Section />
      <Footer />
    </div>
  );
}

export default Homepage;
